"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ZLeaderboardAction = void 0;
const dbEnums_1 = require("@daymade/common-lib/dbEnums");
const zod_1 = require("zod");
exports.ZLeaderboardAction = zod_1.z.nativeEnum(dbEnums_1.LeaderboardAction);
//# sourceMappingURL=models.js.map